// extracted by mini-css-extract-plugin
export default {"fallback-main-component":"ErrorFallbackComponent_fallback-main-component__wEqgL","error-fallabck-exclamation-image":"ErrorFallbackComponent_error-fallabck-exclamation-image__Fj8N4"};